import firebase from '../../firebase';

// initial state
const state = {
    allPackages: [],
    package: null
}

// getters
const getters = {
    allPackages: state => state.allPackages,
    allPackagesByIds(state) {
        return ids => {
            console.log('ids allPackagesByIds', ids)
            console.log('state allPackagesByIds', state)
            const packages = ids.map(id => state.allPackages.find(p => p.value.id == id).value)
            console.log('packages allPackagesByIds', packages)
            return packages
        }
    }
}

// mutations
const mutations = {
    setPackages(state, packages) {
        state.allPackages = packages
    }
}

// actions
const actions = {
    getPackagesById: function (context, id) {

        return new Promise((resolve, reject) => {

        if (id) {
            firebase.database.ref('packages').child(id).once("value", function (snapshot) {
              resolve(snapshot.val());
            }, function (error) { console.log("getPackagesById error", error)
          reject(error)
          })
          }
        });
    },
    savePackageById: function (context, data) {
        console.log("context", context);
        console.log("id", data.id);
        console.log("package", data.package);
        console.log("this.state", this.state);
  
        // var key = (id) ? id : context.getters.product.productname.replace(/\s+/g, '-').toLowerCase();
  
        // console.log("key", key);
  
        firebase.database.ref("packages").child(data.id).set(data.package, function (error) {
          if (error) {
            console.error("error edit/create package", error);
          } else {
            console.log("success edit/create package");
          }
        });
      },
    getAllPackages: function (context) {
        console.log('getAllPackages')
        var packages = [];
        firebase.database.ref("packages").on("value", function (snapshot) {
            snapshot.forEach(function (item) {
                var itemVal = item.val();
                packages.push({ value: { id: item.key, name: itemVal.name, display: itemVal.display, code: itemVal.code, pack: itemVal.pack, toy: itemVal.toy }, text: itemVal.name });
            });
            context.commit('setPackages', packages);
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/packages.js